import { Stack, Typography } from '@mui/material';
import React from 'react';

import { Neutrals } from '../../color-palette/colors';
import { Button } from '../Buttons';
import { PROSE_MAX } from '../Screen/screenLayout';

export interface FeatureErrorStateProps {
  title: string;
  body?: string;
  retryLabel: string;
  retrying?: boolean;
  onRetry: () => void;
  align?: 'start' | 'center';
}

export const FeatureErrorState: React.FC<FeatureErrorStateProps> = ({
  title,
  body,
  retryLabel,
  onRetry,
  retrying = false,
  align = 'center',
}) => (
  <Stack
    spacing={3}
    role="alert"
    alignItems={align === 'center' ? 'center' : 'flex-start'}
    sx={{ py: 8, textAlign: align === 'center' ? 'center' : 'start' }}
  >
    <Typography variant="cardTitleSm" component="h2">
      {title}
    </Typography>
    {body && (
      <Typography variant="caption2" sx={{ color: Neutrals[600], maxWidth: PROSE_MAX }}>
        {body}
      </Typography>
    )}
    <Button intent="secondary" busy={retrying} onClick={onRetry}>
      {retryLabel}
    </Button>
  </Stack>
);
